import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.importReportDownload';

export default defineMessages({
  downloadFile: {
    id: `${scope}.downloadFile`,
    defaultMessage: 'Download File',
  },
  errorType: {
    id: `${scope}.errorType`,
    defaultMessage: 'Error Type',
  },
  errorDescription: {
    id: `${scope}.errorDescription`,
    defaultMessage: 'Error Description',
  },
  location: {
    id: `${scope}.location`,
    defaultMessage: 'Location',
  },
  eventType: {
    id: `${scope}.eventType`,
    defaultMessage: 'Error or Warning',
  },
  error: {
    id: `${scope}.error`,
    defaultMessage: 'Cause',
  },
  errorOrWarning: {
    id: `${scope}.errorOrWarning`,
    defaultMessage: 'Error/Warning Summary',
  },
  errorOrWarningorFatal: {
    id: `${scope}.errorOrWarningorFatal`,
    defaultMessage: 'Fatal/Error/Warning Summary',
  },
  summary: {
    id: `${scope}.summary`,
    defaultMessage: 'Summary',
  },
  fatal: {
    id: `${scope}.fatal`,
    defaultMessage: 'Fatal',
  },
});
